import { Component } from '@angular/core';

@Component({
  selector: 'app-agreements',
  templateUrl: './agreements.component.html',
  styleUrl: './agreements.component.scss'
})
export class AgreementsComponent {

}
